import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem, UserData } from 'src/app/core/interface/toolbar.interface';
import { encriptar } from 'src/app/shared/helpers/encryption';
import { localDB } from 'src/app/shared/helpers/localStorage';
import { environment as env } from 'src/environments/environment';
import { MatMenuModule } from '@angular/material/menu';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';
import { RouterModule } from '@angular/router';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ConfigEnviromentService } from 'src/app/core/service/configEnviroment.service';
import { NotificationService } from 'src/app/core/service/notification.service';

@Component({
  selector: 'mg-toolbar-user',
  standalone: true,
  imports: [MatMenuModule, CommonModule, TitleCasePipe, RouterModule, IconComponent],
  templateUrl: './toolbar-user.component.html',
  styleUrl: './toolbar-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {
  readonly hasUnread = signal<boolean>(false);
  private readonly _notificationService = inject(NotificationService);

  constructor(private readonly config: ConfigEnviromentService) { }

  items: MenuItem[] = [];
  user: UserData = { pic: '', rol: '', name: '', idCollabarator: '' };

  ngOnInit(): void {
    this.config._loadUser$.subscribe((x) => {
      if (x) {
        this.initUserData();
        this.config._loadUser.next(false);
      }
    });
    this.items = this.initItemsMenu();
    this._notificationService.hasUnread$.subscribe((val) => {
      this.hasUnread.set(val);
    });
  }

  toggleNotifications(): void {
    this._notificationService.triggerShow$.next();
  }

  initItemsMenu(): MenuItem[] {
    let id = encriptar(env.securityKey, this.user.idCollabarator);
    return [{
      id: '1',
      icon: 'account_circle',
      label: 'Mi perfil',
      description: 'Información personal',
      route: 'colaboradores/detalle',
      queryParms: { id },
    }];
  }

  initUserData() {
    this.user = {
      pic: localDB.getItem('Profile'),
      rol: localDB.getItem('sNombre_Rol'),
      name: localDB.getItem('sNombres'),
      idCollabarator: localDB.getItem('idColaborador'),
    };
  }
}